var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _vm.$route.query.isMail != 1 && _vm.$route.query.isApp == 1
      ? _c("div", { staticClass: "contract-header" }, [
          _vm.$route.query.isApp == 1
            ? _c("div", [
                _vm.$route.query.backgroundColor == "day"
                  ? _c("img", {
                      class: { mirrorRotateLevel: _vm.isDirection },
                      attrs: {
                        src: require("../assets/images/contractPoint/arrow-moon1.png")
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    })
                  : _c("img", {
                      class: { mirrorRotateLevel: _vm.isDirection },
                      attrs: {
                        src: require("../assets/images//contractPoint/arrow-day1.png")
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    })
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "newBg" }, [
      _vm.startTime_act == null
        ? _c("div", { staticClass: "noActBg" }, [
            _c("img", {
              attrs: {
                src: require("../assets/images/contractPoint/noActBg_h5.png")
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("9100046")))])
          ])
        : _c("div", [
            _c("div", { staticClass: "header" }, [
              _c("div", [
                _c("div", { staticClass: "shdowText1Box" }, [
                  _c(
                    "div",
                    { staticClass: "shdowText1", class: _vm.langShdowText1() },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("9100001")) +
                          "," +
                          _vm._s(_vm.$t("9100002")) +
                          "," +
                          _vm._s(_vm.$t("9100047")) +
                          "\n                            "
                      ),
                      _c(
                        "div",
                        { staticClass: "top", class: _vm.langShdowText1() },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("9100001")) +
                              "," +
                              _vm._s(_vm.$t("9100002")) +
                              "," +
                              _vm._s(_vm.$t("9100047"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bottom", class: _vm.langShdowText1() },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("9100001")) +
                              "," +
                              _vm._s(_vm.$t("9100002")) +
                              "," +
                              _vm._s(_vm.$t("9100047"))
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "headerText" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("9100058")) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "activity_list" }, [
                  _c("div", { staticClass: "activity_list_box" }, [
                    _c("div", { staticClass: "activity_item header_title1" }, [
                      _vm.$route.query.backgroundColor == "day"
                        ? _c("img", {
                            class: _vm.languageText1(),
                            attrs: {
                              src: require("../assets/images/contractPoint/pointIcon1.png")
                            }
                          })
                        : _c("img", {
                            class: _vm.languageText1(),
                            attrs: {
                              src: require("../assets/images/contractPoint/pointIcon1-sunlight.png")
                            }
                          }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("9100001")))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "activity_item header_title2" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/contractPoint/pointIcon2.png")
                        }
                      }),
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("9100002")) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "activity_item header_title2" }, [
                      _c("img", {
                        class: _vm.languageText(),
                        attrs: {
                          src: require("../assets/images/contractPoint/pointIcon3.png")
                        }
                      }),
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("9100003")) +
                          "\n                            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("img", {
                      staticClass: "titleImg",
                      class: { mirrorRotateLevel: _vm.isDirection },
                      attrs: { src: _vm.h5Img }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bg", attrs: { id: "bgTop" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "points_details",
                    style: { "background-image": _vm.getBackgroundImage() }
                  },
                  [
                    _c("div", { staticClass: "points_header" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("9100004")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail" }, [
                        _c("div", { staticClass: "number" }, [
                          _vm._v(
                            _vm._s(
                              _vm.isLogin
                                ? _vm.formatNumber(_vm.availableAmount)
                                : "--"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "to_detail",
                            on: { click: _vm.goPointsDetails }
                          },
                          [
                            _vm._v(
                              "\n\n                                " +
                                _vm._s(_vm.$t("9100005")) +
                                "\n\n                                "
                            ),
                            _c("i", {
                              staticClass: "iconfont history icon-gengduo",
                              class: { mirrorRotateLevel: _vm.isDirection },
                              staticStyle: { display: "inline-block" }
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "points_type_list" }, [
                      _c("div", { staticClass: "points_type_item" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("9100006")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            on: { click: _vm.goPoint_1 }
                          },
                          [
                            _c("div", { staticClass: "number" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.isLogin
                                      ? _vm.formatNumber(_vm.signPointsAmount)
                                      : "--"
                                  ) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              class: { mirrorRotateLevel: _vm.isDirection },
                              attrs: {
                                src: require("../assets/images//contractPoint/goRightH5.png")
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "points_type_item" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("9100007")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            on: { click: _vm.goPoint_2 }
                          },
                          [
                            _c("div", { staticClass: "number" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.isLogin
                                      ? _vm.formatNumber(_vm.tradePointsAmount)
                                      : "--"
                                  ) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              class: { mirrorRotateLevel: _vm.isDirection },
                              attrs: {
                                src: require("../assets/images//contractPoint/goRightH5.png")
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "points_type_item" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("9100008")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            on: { click: _vm.goPoint_3 }
                          },
                          [
                            _c("div", { staticClass: "number" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.isLogin
                                      ? _vm.formatNumber(_vm.invitePointsAmount)
                                      : "--"
                                  ) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              class: { mirrorRotateLevel: _vm.isDirection },
                              attrs: {
                                src: require("../assets/images//contractPoint/goRightH5.png")
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "points_type_item" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("9100009")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            on: { click: _vm.goPoint_4 }
                          },
                          [
                            _c("div", { staticClass: "number" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.isLogin
                                      ? _vm.formatNumber(_vm.rewardPointsAmount)
                                      : "--"
                                  ) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              class: { mirrorRotateLevel: _vm.isDirection },
                              attrs: {
                                src: require("../assets/images//contractPoint/goRightH5.png")
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.isOpenPoint == true
                  ? _c("div", { staticClass: "pointsMsgHeight" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpenPoint == 0,
                        expression: "isOpenPoint == 0"
                      }
                    ],
                    staticClass: "pointsMsg"
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("9100033")))])]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "get_points_title" }, [
                  _c("div", { staticClass: "title_left" }, [
                    _c("div", { staticClass: "title_icon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title_text" }, [
                      _vm._v(_vm._s(_vm.$t("9100032")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "title_right" },
                    [
                      _vm.isOpenPoint == true
                        ? _c("div", {
                            staticClass: "tranBox",
                            on: {
                              click: function($event) {
                                _vm.failPoint = true
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("van-switch", {
                        attrs: { "active-color": "#FFC72B" },
                        on: { change: _vm.handleChangeStatus },
                        model: {
                          value: _vm.isOpenPoint,
                          callback: function($$v) {
                            _vm.isOpenPoint = $$v
                          },
                          expression: "isOpenPoint"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sign_points" }, [
                  _c("div", { staticClass: "sign_header" }, [
                    _vm.$route.query.backgroundColor == "day"
                      ? _c("div", { staticClass: "icon iconDay" })
                      : _c("div", { staticClass: "icon iconMoon" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "open_btn",
                        on: {
                          click: function($event) {
                            _vm.openSignSpeedBox = !_vm.openSignSpeedBox
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "open_btn-text openIcon" }, [
                          _vm._v(_vm._s(_vm.$t("9100006")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "open_btn_icon",
                            class: { open: _vm.openSignSpeedBox }
                          },
                          [
                            _vm.$route.query.backgroundColor == "day"
                              ? _c("img", {
                                  attrs: {
                                    src: require("../assets/images/contractPoint/arrow-moon.png")
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../assets/images/contractPoint/arrow-day.png")
                                  }
                                })
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info" }, [
                    _vm._v(_vm._s(_vm.$t("9100034")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sign_speed_box",
                      class: { open: _vm.openSignSpeedBox }
                    },
                    [
                      _vm._l(_vm.noTokenMsgList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "sign_speed_item",
                            class: { reach: index + 1 <= _vm.continueDay }
                          },
                          [
                            index + 1 <= _vm.continueDay
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "points_box",
                                    on: { click: _vm.goContract_1 }
                                  },
                                  [
                                    _c("div", { staticClass: "icon_1" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "icon_2" })
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "points_box",
                                    on: { click: _vm.goContract_1 }
                                  },
                                  [
                                    _c("div", { staticClass: "icon_3" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "points_num" }, [
                                      _vm._v(_vm._s(item.amount))
                                    ])
                                  ]
                                ),
                            _vm._v(" "),
                            _c("div", { staticClass: "day_box" }, [
                              _vm._v(
                                "\n                                DAY" +
                                  _vm._s(item.day) +
                                  "\n                            "
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "sign_speed_line",
                          class: { mirrorRotateLevel: _vm.isDirection }
                        },
                        [
                          _c("div", {
                            staticClass: "sign_speed_line_reach",
                            style: {
                              right: (100 / 6) * (7 - _vm.continueDay) + "%"
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(7, function(item) {
                            return _c("div", {
                              key: item,
                              staticClass: "sign_speed_circle",
                              class: { reach: item <= _vm.continueDay },
                              style: { left: (100 / 6) * (item - 1) + "%" }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info_1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("9100015", {
                          day: _vm.isLogin ? _vm.continueDay : "--",
                          num: _vm.isLogin
                            ? _vm.formatNumber(_vm.amountSignIn)
                            : "--"
                        })
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "to_trade_btn",
                      on: { click: _vm.goContract_1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("300083")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "points_type_item_two" }, [
                  _c("div", { staticClass: "sign_header" }, [
                    _vm.$route.query.backgroundColor == "day"
                      ? _c("div", { staticClass: "icon iconDay" })
                      : _c("div", { staticClass: "icon iconMoon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "open_btn" }, [
                      _c("div", { staticClass: "open_btn-text" }, [
                        _vm._v(_vm._s(_vm.$t("9100007")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          staticClass: "icon tishigantan",
                          staticStyle: { cursor: "pointer" },
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function($event) {
                              _vm.isShowNewBox1 = true
                            }
                          }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-tishi-copy" }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info" }, [
                    _vm._v(_vm._s(_vm.$t("9100035")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info_1" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("9100016", {
                            num: _vm.isLogin
                              ? _vm.formatNumber(_vm.tradePointsAmount_day)
                              : "--"
                          })
                        ) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "to_trade_btn",
                      on: { click: _vm.goContract_2 }
                    },
                    [_vm._v(_vm._s(_vm.$t("300083")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "points_type_item_two" }, [
                  _c("div", { staticClass: "sign_header" }, [
                    _vm.$route.query.backgroundColor == "day"
                      ? _c("div", { staticClass: "icon iconDay" })
                      : _c("div", { staticClass: "icon iconMoon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "open_btn" }, [
                      _c("div", { staticClass: "open_btn-text" }, [
                        _vm._v(_vm._s(_vm.$t("9100036")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          staticClass: "icon tishigantan",
                          staticStyle: { cursor: "pointer" },
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function($event) {
                              _vm.isShowNewBox2 = true
                            }
                          }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-tishi-copy" }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info" }, [
                    _vm._v(_vm._s(_vm.$t("9100037")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info_1" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("9100016", {
                            num: _vm.isLogin
                              ? _vm.formatNumber(_vm.rankPointsAmount_day)
                              : "--"
                          })
                        ) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "to_trade_btn",
                      on: { click: _vm.goContract_3 }
                    },
                    [_vm._v(_vm._s(_vm.$t("300083")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "points_type_item_two" }, [
                  _c("div", { staticClass: "sign_header" }, [
                    _vm.$route.query.backgroundColor == "day"
                      ? _c("div", { staticClass: "icon iconDay" })
                      : _c("div", { staticClass: "icon iconMoon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "open_btn" }, [
                      _c("div", { staticClass: "open_btn-text" }, [
                        _vm._v(_vm._s(_vm.$t("9100008")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          staticClass: "icon tishigantan",
                          staticStyle: { cursor: "pointer" },
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function($event) {
                              _vm.isShowNewBox3 = true
                            }
                          }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-tishi-copy" }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info" }, [
                    _vm._v(_vm._s(_vm.$t("9100038")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sign_info_1" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("9100016", {
                            num: _vm.isLogin
                              ? _vm.formatNumber(_vm.invitePointsAmount_day)
                              : "--"
                          })
                        ) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "to_trade_btn",
                      on: { click: _vm.goContract_4 }
                    },
                    [_vm._v(_vm._s(_vm.$t("300069")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "points_rule" }, [
                  _c(
                    "div",
                    { staticClass: "text", on: { click: _vm.goPointRuler } },
                    [_vm._v(_vm._s(_vm.$t("9100012")))]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "iconfont history icon-gengduo rulerArw",
                    class: { mirrorRotateLevel: _vm.isDirection },
                    staticStyle: { display: "inline-block" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wheelLottery" }, [
                  _c("div", { staticClass: "wheelLottery-title" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/contractPoint/wheelIcon.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "titleText" }, [
                      _vm._v(_vm._s(_vm.$t("9100010")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wheelLottery-content" }, [
                    _vm.winList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "notice-bar" },
                          [
                            _c(
                              "van-swipe",
                              {
                                staticClass: "notice-swipe",
                                attrs: {
                                  vertical: "",
                                  autoplay: 1500,
                                  "show-indicators": false
                                }
                              },
                              _vm._l(_vm.winList, function(item, index) {
                                return _c("van-swipe-item", { key: index }, [
                                  _c("img", {
                                    class: {
                                      mirrorRotateLevel: _vm.isDirection
                                    },
                                    attrs: {
                                      src: require("../../static/images/congratulations.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("9100039", {
                                          guy: item.account,
                                          num: _vm.formatNumber(
                                            item.pointAmount
                                          )
                                        })
                                      )
                                    }
                                  })
                                ])
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "LuckyWheel" }, [
                      _c("img", {
                        staticClass: "LuckyWheel-img",
                        attrs: {
                          src: require("../assets/images/contractPoint/wheelBg.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "LuckyWheel-content" }, [
                        _c("div", { staticClass: "drawBox" }, [
                          _c(
                            "div",
                            {
                              ref: "drwaImg",
                              staticClass: "drawImg",
                              attrs: { alt: "" }
                            },
                            _vm._l(_vm.wheelPointList, function(item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "num",
                                  style: {
                                    left: item.x + "%",
                                    top: item.y + "%",
                                    transform:
                                      " translateX(-50%) translateY(-50%) rotate(" +
                                      item.jiaodu +
                                      "deg)"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(
                                        _vm.wheelPointList.length >= 8 &&
                                          _vm.prizes[7 - index] &&
                                          _vm.prizes[7 - index].drawAmount
                                          ? _vm.prizes[7 - index].drawAmount
                                          : ""
                                      ) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "ss",
                            attrs: {
                              src: require("../assets/images/contractPoint/wheelBtn.png"),
                              alt: ""
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wheelFloor" }, [
                        _c("img", {
                          staticClass: "wheelFloor-img",
                          attrs: {
                            src: require("../assets/images/contractPoint/wheelFloor.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "wheelFloorText1" }, [
                          _vm._v(_vm._s(_vm.formatNumber(_vm.numberPrize)))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "wheelFloorText2" }, [
                          _vm._v(_vm._s(_vm.$t("9100017")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "wheelLottery-content-text" }, [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("9100004")) +
                            "：" +
                            _vm._s(_vm.isLogin ? _vm.availableAmount : "--")
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wheelLotteryText2" }, [
                        _vm._v(
                          _vm._s(_vm.$t("9100019")) +
                            "：" +
                            _vm._s(_vm.isLogin ? _vm.drawsNumber : "--") +
                            "/" +
                            _vm._s(_vm.maxDailyDraws)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm.language === "ru" || _vm.language === "uk"
                          ? _c("span", { staticClass: "pointText" }, [
                              _vm._v("-")
                            ])
                          : _c("span", { staticClass: "pointText" }, [
                              _vm._v("·")
                            ]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t("9100018", {
                                point: _vm.formatNumber(
                                  _vm.pointsPerDrawAmount
                                ),
                                num: _vm.maxDailyDraws
                              })
                            ) +
                            "\n                            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "wheelLotteryBtn",
                        on: { click: _vm.startCallback }
                      },
                      [_vm._v(_vm._s(_vm.$t("9100040")))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rankContent" }, [
                  _c("div", { staticClass: "rankContent-title" }, [
                    _c("img", {
                      staticClass: "rankContent-title-img",
                      attrs: {
                        src: require("../assets/images/contractPoint/rankIcon.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "rankContent-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("300070")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rankContent-content" }, [
                    _c("div", { staticClass: "rankContent-content-title" }, [
                      _c("div", [_vm._v(_vm._s(_vm.$t("300084")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rankDiv2" }, [
                        _vm._v(_vm._s(_vm.$t("9100020")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rankDiv3" }, [
                        _vm._v(_vm._s(_vm.$t("9100021")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rankContent-content-list" },
                      [
                        _c(
                          "div",
                          { staticClass: "rankScrollbar" },
                          _vm._l(_vm.rankList, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "rankListListMain",
                                class: {
                                  lastItem: index === _vm.rankList.length - 1
                                }
                              },
                              [
                                _c("div", { staticClass: "listMainIcon" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "listMainIcon-img",
                                      style: {
                                        "background-image": _vm.getBackgroundImageIcon(
                                          index
                                        )
                                      }
                                    },
                                    [_c("span", [_vm._v(_vm._s(index + 1))])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "listMainTest rankText2" },
                                  [_c("span", [_vm._v(_vm._s(item.account))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "listMainTest rankText3" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatNumber(item.pointAmount)
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "van-empty",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.rankList.length == 0,
                                expression: "rankList.length == 0"
                              }
                            ],
                            staticClass: "custom-image",
                            attrs: { description: _vm.$t("300108") }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "icon emptyIcon",
                                attrs: { slot: "image", "aria-hidden": "true" },
                                slot: "image"
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xlink:href":
                                      _vm.$route.query.backgroundColor == "day"
                                        ? "#icon-jilu1"
                                        : "#icon-zanwujilu"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "newBox1",
                    model: {
                      value: _vm.isShowNewBox1,
                      callback: function($$v) {
                        _vm.isShowNewBox1 = $$v
                      },
                      expression: "isShowNewBox1"
                    }
                  },
                  [
                    _c("div", { staticClass: "rewardModel" }, [
                      _c("div", { staticClass: "rewardModel-main" }, [
                        _c("div", { staticClass: "rewardModel-main-title" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("9100007")))]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "icon arrow",
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function($event) {
                                  _vm.isShowNewBox1 = false
                                }
                              }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-guanbi1" }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rewardModel-main-content" }, [
                          _vm._v(
                            "\n                                1." +
                              _vm._s(_vm.$t("9100035")) +
                              "\n                                "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("9100055")) +
                              "\n                                "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                2." +
                              _vm._s(_vm.$t("9100056"))
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                3." +
                              _vm._s(_vm.$t("9100057")) +
                              "\n                            "
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "newBox2",
                    model: {
                      value: _vm.isShowNewBox2,
                      callback: function($$v) {
                        _vm.isShowNewBox2 = $$v
                      },
                      expression: "isShowNewBox2"
                    }
                  },
                  [
                    _c("div", { staticClass: "rewardModel" }, [
                      _c("div", { staticClass: "rewardModel-main" }, [
                        _c("div", { staticClass: "rewardModel-main-title" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("9100036")))]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "icon arrow",
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function($event) {
                                  _vm.isShowNewBox2 = false
                                }
                              }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-guanbi1" }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rewardModel-main-content" }, [
                          _vm._v(
                            "\n                                1." +
                              _vm._s(_vm.$t("9100037"))
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                2." +
                              _vm._s(_vm.$t("9100059"))
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("table", { staticClass: "rankTable" }, [
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.$t("9100060")) +
                                    "\n                                        "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "rankTd2" }, [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.$t("9100009")) +
                                    "\n                                        "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.$t("9100061")) +
                                    "\n                                        "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "rankTd2" }, [
                                _vm._v("20%")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$t("9100062")))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "rankTd2" }, [
                                _vm._v("10%")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$t("9100063")))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "rankTd2" }, [
                                _vm._v("5%")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$t("9100064")))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "rankTd2" }, [
                                _vm._v("3%")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$t("9100065")))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "rankTd2" }, [
                                _vm._v("1%")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "newBox3",
                    model: {
                      value: _vm.isShowNewBox3,
                      callback: function($$v) {
                        _vm.isShowNewBox3 = $$v
                      },
                      expression: "isShowNewBox3"
                    }
                  },
                  [
                    _c("div", { staticClass: "rewardModel" }, [
                      _c("div", { staticClass: "rewardModel-main" }, [
                        _c("div", { staticClass: "rewardModel-main-title" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("9100008")))]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "icon arrow",
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function($event) {
                                  _vm.isShowNewBox3 = false
                                }
                              }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-guanbi1" }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rewardModel-main-content" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("9100066"))
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("9100068")) +
                              "\n                                "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("9100069")) +
                              "\n                                "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("9100070")) +
                              "\n                                "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("9100071")) +
                              "\n                                "
                          ),
                          _c("div", { staticClass: "levelTitle" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("9100067")) +
                                "\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "table",
                            { staticClass: "invTable", attrs: { border: "1" } },
                            [
                              _c("tr", [
                                _c("td", { staticClass: "td1" }, [
                                  _vm._v(_vm._s(_vm.$t("9100060")))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td2" }, [
                                  _vm._v(_vm._s(_vm.$t("9100072")))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td3" })
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "td1" }, [_vm._v("1")]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td2" }, [
                                  _vm._v("15%")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td3" }, [
                                  _vm._v(_vm._s(_vm.$t("9100073")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "td1" }, [_vm._v("2")]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td2" }, [
                                  _vm._v("20%")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td3" }, [
                                  _vm._v(_vm._s(_vm.$t("9100074")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "td1" }, [_vm._v("3")]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td2" }, [
                                  _vm._v("30%")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td3" }, [
                                  _vm._v(_vm._s(_vm.$t("9100075")))
                                ])
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "rulerBox",
                    model: {
                      value: _vm.isShowPointRuler,
                      callback: function($$v) {
                        _vm.isShowPointRuler = $$v
                      },
                      expression: "isShowPointRuler"
                    }
                  },
                  [
                    _c("div", { staticClass: "rewardModel" }, [
                      _c("div", { staticClass: "rewardModel-main" }, [
                        _c("div", { staticClass: "rewardModel-main-title" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("9100012")))]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "icon arrow",
                              attrs: { "aria-hidden": "true" },
                              on: { click: _vm.closePointRuler }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-guanbi1" }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rewardModel-main-content" }, [
                          _c("p", {
                            domProps: { innerHTML: _vm._s(_vm.rulerMsg) }
                          })
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "tip-popup",
                    style: { width: "15.6rem", padding: "1.2rem" },
                    attrs: { round: "" },
                    model: {
                      value: _vm.noPoints,
                      callback: function($$v) {
                        _vm.noPoints = $$v
                      },
                      expression: "noPoints"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon boxIcon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100022")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100023")))]),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "confirmBtn",
                            on: { click: _vm.noPointsConfirm }
                          },
                          [_vm._v(_vm._s(_vm.$t("9100032")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "cancalBtn",
                            on: {
                              click: function($event) {
                                _vm.noPoints = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("300111")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "tip-popup",
                    style: { width: "15.6rem", padding: "1.2rem" },
                    attrs: { round: "" },
                    model: {
                      value: _vm.noNumber,
                      callback: function($$v) {
                        _vm.noNumber = $$v
                      },
                      expression: "noNumber"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon boxIcon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100024")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100025")))]),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "confirmBtn",
                            on: {
                              click: function($event) {
                                _vm.noNumber = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("300286")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "tip-popup",
                    style: { width: "15.6rem", padding: "1.2rem" },
                    attrs: { round: "" },
                    model: {
                      value: _vm.getPoints,
                      callback: function($$v) {
                        _vm.getPoints = $$v
                      },
                      expression: "getPoints"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon boxIcon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100026")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100027")))]),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "confirmBtn",
                            on: { click: _vm.getPointsConfirm }
                          },
                          [_vm._v(_vm._s(_vm.$t("9100044")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "cancalBtn",
                            on: { click: _vm.tranAgain }
                          },
                          [_vm._v(_vm._s(_vm.$t("9100045")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "tip-popup",
                    style: { width: "15.6rem", padding: "1.2rem" },
                    attrs: { round: "" },
                    model: {
                      value: _vm.sucPoint,
                      callback: function($$v) {
                        _vm.sucPoint = $$v
                      },
                      expression: "sucPoint"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon boxIcon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100028")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100029")))]),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "confirmBtn",
                            on: { click: _vm.toSucPoint }
                          },
                          [_vm._v(_vm._s(_vm.$t("300083")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "cancalBtn",
                            on: {
                              click: function($event) {
                                _vm.sucPoint = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("9100043")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "tip-popup",
                    style: { width: "15.6rem", padding: "1.2rem" },
                    attrs: { round: "" },
                    model: {
                      value: _vm.sucPoint2,
                      callback: function($$v) {
                        _vm.sucPoint2 = $$v
                      },
                      expression: "sucPoint2"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon boxIcon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100028")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("9100029")))]),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "confirmBtn",
                            on: { click: _vm.toSucPoint }
                          },
                          [_vm._v(_vm._s(_vm.$t("300083")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "tip-popup",
                    style: { width: "15.6rem", padding: "1.2rem" },
                    attrs: { round: "" },
                    model: {
                      value: _vm.failPoint,
                      callback: function($$v) {
                        _vm.failPoint = $$v
                      },
                      expression: "failPoint"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon boxIcon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "bold" }, [
                          _vm._v(_vm._s(_vm.$t("9100030")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "confirmBtn",
                            on: { click: _vm.failPointConfirm }
                          },
                          [_vm._v(_vm._s(_vm.$t("300287")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "van-button",
                          {
                            staticClass: "cancalBtn",
                            on: {
                              click: function($event) {
                                _vm.failPoint = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("300111")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    staticClass: "sucPointsBox",
                    model: {
                      value: _vm.ishowSevenFinishBg,
                      callback: function($$v) {
                        _vm.ishowSevenFinishBg = $$v
                      },
                      expression: "ishowSevenFinishBg"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "finishModel",
                        class: [
                          "finishModel",
                          { "finishModel-fa": _vm.language === "fa" }
                        ]
                      },
                      [
                        _c("div", { staticClass: "finishModel-img" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("9100041")))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "getPoints_box" }, [
                            _c("span", { staticClass: "span_1" }, [
                              _vm._v(_vm._s(_vm.formatNumber(_vm.getSucPoints)))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "span_2" }, [
                              _vm._v(_vm._s(_vm.$t("9100021")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "finishModelBtn" }, [
                            _c(
                              "div",
                              {
                                staticClass: "again",
                                on: { click: _vm.wheelAgain }
                              },
                              [_vm._v(_vm._s(_vm.$t("300286")))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "icon finishModelIcon",
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function($event) {
                                _vm.ishowSevenFinishBg = false
                              }
                            }
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-guanbi2" }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bottomBox" })
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25ed0b4d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ed0b4d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/contractPoint.vue
// module id = dmFH
// module chunks = 0